export default __webpack_public_path__ + "static/media/powerDim.469d76e5.svg";